import React from "react";
import { Field, Formik } from "formik";
import { Button, notification, Card, Form, Input } from "antd/lib/index";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  editGroupAction,
  removeStudentFromGroup
} from "../../../../redux/actions/groups";
import { selectGroupByKey } from "../../../../redux/selectors/groups";
import SelectStudents from "../../../ui/SelectStudents";
import { selectUsersByIds } from "../../../../redux/selectors/users";

const CustomInputComponent = ({ field, ...props }) => {
  return (
    <Form.Item label={props.label}>
      <Input type={props.type ? props.type : "text"} {...field} {...props} />
    </Form.Item>
  );
};

class EditGrupoForm extends React.Component {
  openNotificationWithIcon = type => {
    notification[type]({
      message: "Grupo editado exitosamente"
    });
  };

  render() {
    const { group, onEditGroup, groupKey } = this.props;
    return (
      <Formik
        initialValues={{ ...group }}
        onSubmit={values => {
          onEditGroup(groupKey, values);
        }}
        render={props => (
          <React.Fragment>
            <Card>
              <Card.Grid style={{ width: "70%" }}>
                <Field
                  label="Nombre"
                  name="nombreGrupo"
                  component={CustomInputComponent}
                />
                <Field
                  label="Colegio"
                  name="colegio"
                  component={CustomInputComponent}
                />
                <Field
                  label="Nivel"
                  name="nivel"
                  type="number"
                  component={CustomInputComponent}
                />
                <Field
                  label="Identificador de nivel"
                  name="identificadorNivel"
                  component={CustomInputComponent}
                />
                <Form.Item label="Select Students">
                  <SelectStudents
                    {...props}
                    nivel={props.values.nivel}
                    colegio={props.values.colegio}
                    identificadorNivel={props.values.identificadorNivel}
                    groupKey={this.props.groupKey}
                  />
                </Form.Item>
              </Card.Grid>
            </Card>
            <Button onClick={props.handleSubmit}>Submit</Button>
          </React.Fragment>
        )}
      />
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { onEditGroup: editGroupAction, removeStudentFromGroup },
    dispatch
  );

const mapStateToProps = (state, ownProps) => {
  const groupKey = ownProps.computedMatch.params.id;
  const group = selectGroupByKey(state, groupKey);
  const students = studentIds => selectUsersByIds(state, studentIds);

  return {
    groupKey,
    group,
    students
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditGrupoForm);
